import React from 'react';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';

import { mq } from '../../_style';

import imgMain from '../../assets/imgs/about/archive/img-main.jpg';
import imgMainSp from '../../assets/imgs/about/archive/sp/img-main.jpg';

import AboutMain from '../../components/organisms/aboutDetail/aboutDetailMain';
import SectionLineup from '../../components/organisms/sectionLineup';
import ArticleWrap from '../../components/organisms/articleWrap';
import ArticleBody from '../../components/organisms/articleBody';
import InnerLinkGroup from '../../components/molecules/about/innerLinkGroup';
import ArticleHeader from '../../components/molecules/articleHeader';
import ArticleSection from '../../components/molecules/articleSection';
import TextBlock from '../../components/molecules/textBlock';
import TextBlockGrid from '../../components/molecules/textBlockGrid';
import ArticleImage from '../../components/atoms/articleImage';
import ArticleHeading from '../../components/atoms/articleHeading';
import ArticleItemName from '../../components/atoms/articleItemName';
import Text from '../../components/atoms/text';
import Caption from '../../components/atoms/caption';

const Container = styled.div`
`;
const ImgSub = styled.div`
  flex: 1 0 auto;
  ${mq.pc} {
    width: 160px;
  }
  ${mq.sp} {
    flex: 0 0 240px;
  }
`;

const ColumnDetail = (props) => {
  return(
    <Container>
      <Helmet
          title="こんなモンダミンあったの!? 過去のレアアイテムを一挙ご紹介！ | モンダミン 公式サイト | アース製薬"
          meta={[
              { name: 'description', content: 'これまでに発売されたモンダミンシリーズの中から、懐かしのアイテムや限定品など個性豊かなアイテムをご紹介します。' },
              { name: 'keywords', content: 'モンダミン,もんだみん,mondahmin,オーラルケア,アース製薬' }
          ]}
        >
        <body data-block-header="true" />
      </Helmet>
      <AboutMain bg={imgMain} bgSp={imgMainSp}></AboutMain>
      <ArticleWrap>
        <ArticleBody>
          <ArticleHeader sub={<>こんなモンダミンあったの!?</>} title={<>過去のレアアイテムを一挙ご紹介！</>}>
            これまでに発売されたモンダミンシリーズの中から、<br />懐かしのアイテムや限定品など個性豊かなアイテムを集結！<br />あなたの知らないモンダミンがここに…！？
          </ArticleHeader>
          <ArticleSection>
            <TextBlock>
              <Text>「お口、クチュ、クチュ。」でおなじみのモンダミンは、1987年の発売から現在に至るまでにさまざまなアイテムを発売してきました。洗口液を日常の習慣として取り入れていただけるように、お子様から高年齢の方までどなたでも最適な1本を選べることが重要と考えていたためです。</Text>
              <Text>今回は、過去に存在したモンダミンの中から、懐かしいものから知られざるレアなものまで、思わず「こんなのあったの!?」と驚くこと間違いなしのアイテムの数々をご紹介いたします。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection>
            <TextBlock>
              <ArticleImage filename={'about/archive/img-01.png'}></ArticleImage>
              <ArticleItemName>モンダミン シナモン</ArticleItemName>
              <Text>1988年、ペパーミントに次いで、「モンダミン　シナモン」が発売されました。当時、アメリカで洗口液のフレーバーとしてポピュラーだったシナモン味が日本人に親しみのある“ニッキ”のような香味であることにモンダミンは注目し、商品化へ。その後2007年まで発売され、一部のコアなファンの方々に愛され続けたアイテムでした。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection>
            <TextBlock>
              <ArticleImage filename={'about/archive/img-02.png'}></ArticleImage>
              <ArticleItemName>モンダミン ベリーミント</ArticleItemName>
              <Text>2006～2007年に発売していたのが、20～30代の女性をターゲットにしたフレッシュベリー味の「モンダミン　ベリーミント」。「お口すっきり！息までカワイイ♡」をコンセプトに、かわいいピンクのパッケージと、ピリピリしないマイルドな香味で、従来の洗口液とは違う印象のモンダミンが誕生しました。</Text>
              <TextBlockGrid align={'right'} spWrap>
                <ImgSub><ArticleImage filename={'about/archive/img-rikachan.png'}></ArticleImage></ImgSub>
                <div>
                  <ArticleHeading>20周年記念はリカちゃんとコラボ！</ArticleHeading>
                  <Text>モンダミンの20周年を記念して、2007年にはあの“リカちゃん”とコラボレーション！ベリーミントとペパーミントのフレーバーをイメージした白衣姿のオリジナルのリカちゃん人形をプレゼントする企画は、大変ご好評をいただきました。</Text>
                </div>
              </TextBlockGrid>
            </TextBlock>
          </ArticleSection>
          <ArticleSection>
            <TextBlock>
              <ArticleImage filename={'about/archive/img-03.png'}></ArticleImage>
              <ArticleItemName>モンダミン リッチアップルミント<br />モンダミン ピンクシャンパーニュ</ArticleItemName>
              <Text>2015年に企画品として発売されたのは、まるでカクテルのような大人フレーバー、「モンダミン　リッチアップルミント」と「モンダミン　ピンクシャンパーニュ」。特徴的なクリスタルカットのボトルが魅力的なこのアイテムは、働く女性に向けて発売されたもの。歴代モンダミンの中でも珍しい、ちょっとラグジュアリーなモンダミンでした。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection>
            <TextBlock>
              <ArticleImage filename={'about/archive/img-04.png'}></ArticleImage>
              <ArticleItemName>モンダミン For MEN</ArticleItemName>
              <Text>「デキる男の新習慣！」を合言葉に、働く男性に向けて2016年に企画品として発売した「モンダミン　For MEN」はクールなブラックミントの香味。吸着・洗浄、Wの働きで、口臭予防に効果的なモンダミンです。<br />男性のお口のお悩み上位にランクインする“口臭”ですが、実は男性の洗口液の使用率は高くありません。そこで、男性に手に取っていただきやすいようにブラック＆シルバーのカラーリングでクールなデザインに仕上げました。</Text>
            </TextBlock>
          </ArticleSection>
          <ArticleSection>
            <TextBlock>
              <ArticleImage filename={'about/archive/img-05.png'}></ArticleImage>
              <ArticleItemName>モンダミン ダブルアクティブ<br />フレッシュハーブ＆アイスミント<br />フレッシュピーチ＆クールシトラス</ArticleItemName>
              <Text>2017年の企画品として、日本初*“2層タイプ”の洗口液をモンダミンから発売しました。「ダブルアクティブ」は個性的なボトルとカラフルな見た目でインパクト大！オイル層とウォーター層に分かれているのでよく振ってからお使いいただくと、スイーツから肉料理まで様々な油汚れに洗浄効果があるだけでなく、爽やかな香りが長続きする優れもの。1歩先を行くモンダミンでした。</Text>
              <Caption>＊アース製薬調べ</Caption>
            </TextBlock>
          </ArticleSection>
          <ArticleSection>
            <TextBlock>
              <Text>モンダミンには豊富なラインナップが存在しますが、使用場面やお口の悩みに合わせて使い分けていただけるよう、今後もリサーチや開発に力を注いでいきます。 ますますパワーアップして“攻めた”アイテムが登場する可能性も…!?これからも新しいモンダミンの登場を、ぜひご期待ください！</Text>
            </TextBlock>
          </ArticleSection>
        </ArticleBody>
        <InnerLinkGroup path={props.path}></InnerLinkGroup>
      </ArticleWrap>
      <SectionLineup></SectionLineup>
    </Container>
  );
};
export default ColumnDetail;
